import { InjectionKey } from 'vue';
import { useUsersPageProvider } from './users.helpers';

export const IKUsersPage = Symbol('IKUsersPage') as InjectionKey<ReturnType<typeof useUsersPageProvider>>;
